import { toastfy } from "../partials/toast/Toast";

export function showErrorMessage(status: number, message: string | string[]) {
    
  let type = null;
  
  if(status >= 300){
    type = "error";
  }

  if(status >= 400){
    type = "warning";
  }

  if(status >= 500){
    type = "error";
  }

  if(Array.isArray(message)){
    message = message.join("\n");
  }
  
  toastfy(
    type ?? "error",
    message ?? "Ocorreu algum erro! Por favor, contate o suporte."
  );
}
